export const antdTheme = {
  token: {
    // Brand colors
    colorPrimary: '#8B81FF',
    colorInfo: '#89CFF0',
    colorSuccess: '#95D5B2',
    colorWarning: '#FFD166',
    colorError: '#F4978E',

    // Background colors
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#F8F9FA',
    colorBgElevated: '#FFFFFF',
    colorBgSpotlight: '#F1F3F5',

    // Text colors
    colorText: '#212529',
    colorTextSecondary: '#6C757D',
    colorTextTertiary: '#ADB5BD',
    colorTextQuaternary: '#CED4DA',

    // Border colors
    colorBorder: '#E9ECEF',
    colorBorderSecondary: '#DEE2E6',

    // Border radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    // Font
    fontFamily: "'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,

    // Box shadow
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    boxShadowSecondary: '0 4px 12px rgba(0, 0, 0, 0.06)',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Table: {
      borderRadius: 12,
      headerBg: '#F1F3F5',
      headerColor: '#6C757D',
    },
    Tag: {
      borderRadiusSM: 6,
    },
    Modal: {
      borderRadiusLG: 16,
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      itemSelectedBg: 'rgba(139, 129, 255, 0.1)',
      itemSelectedColor: '#8B81FF',
      itemHoverBg: 'rgba(139, 129, 255, 0.05)',
    },
    Tooltip: {
      colorBgSpotlight: '#1f1f1f',
      colorTextLightSolid: '#ffffff',
    },
  },
}
